import { useState } from "react"
import PreviewMenuBar from "./previewMenuBar"
import MainPageBody from "./IntroductionLayer/mainPageBody"
import './mainPage.css'
import FeaturesAndBenetfitsCarusel from "./BottomLayers/featuresAndBenetfitsCarusel"
import CustomerSatisfaction from "./BottomLayers/customerSatisfaction"
import DownloadApplicationSection from "../Components/downloadApplicationSection"
import RequestDemo from "../Components/requestDemoSection"
import Footer from "../Components/footer"

const MainPage = () => {

    const [lang, setLang] = useState<any>({ name: 'EN', code: 'GB', lang: "en" })

    const imagesWithDescriptions = [
        {
            src: "/JourneyMap-1.png",
            desc: "The patient suffers from back pain."
        },
        {
            src: "/JourneyMap-2.png",
            desc: "The patient decides to consult a clinician."
        },
        {
            src: "/JourneyMap-3.png",
            desc: "The clinician listens to the patient's complaint."
        },
        {
            src: "/JourneyMap-4.png",
            desc: "Clinician open App selects exercises on the patient's complaints."
        },
        {
            src: "/JourneyMap-5.png",
            desc: "The clinician gives the QR code containing the exercises to patient."
        },
        {
            src: "/JourneyMap-6.png",
            desc: "Downloads the app from the App Store with the help of a QR code."
        },
        {
            src: "/JourneyMap-7.png",
            desc: "The patient completes exercises wishes at home or wherever."
        },
        {
            src: "/JourneyMap-8.png",
            desc: "The clinicians evaluates the patient's exercise reports through the App"
        }
    ]

    return (
        <div className="flex flex-column overflow-x-hidden">
            {/* Main Page */}
            <div className="flex flex-column gap-2"
                style={{
                    width: "100%",
                    minHeight: "100vh",
                    backgroundImage: "url('/MainPageLayout.jpg')",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative"
                }}>

                <div className="flex justify-content-between align-items-center px-2 py-3">
                    <PreviewMenuBar lang={lang} setLang={setLang} />
                </div>

                <div className="flex justify-content-between align-items-center">
                    <MainPageBody />
                </div>
            </div>

            {/*  AI Care */}
            <div className="flex flex-wrap justify-content-evenly align-items-center gap-8 px-4 md:px-8 py-8">
                <div className="flex flex-column align-items-start gap-4 flex-grow-1" style={{ width: "40rem" }} >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >AI CARE</p>
                    <p className="m-0 font-bold" style={{ color: "#2D3967", fontSize: "4.25rem", wordBreak: "break-word" }} >What’s  Mobithera™<span style={{ color: "#E3506B" }}>?</span></p>
                    <p className="m-0 text-xl flex-grow-1" style={{ color: "#727A99", textWrap: "wrap" }}>
                        Mobithera delivers clinically guided rehabilitation. Using AI-powered motion tracking and real-time exercise analysis and feedbacks, Mobithera provides safe, personalized therapy programs without the need for auxiliary equipment.
                    </p>
                    <p className="m-0 mt-6" style={{ color: "#2D3967", fontSize: "2rem", fontWeight: 700 }} >For<span style={{ color: "#E3506B" }}> Everyone !</span></p>
                </div>
                <img src="/MainMenuOldMan.png" className="flex-grow-1 w-20rem xl:w-30rem" />
            </div>

            {/*  How It Works */}
            <div style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/RequestDemoBackground.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative"
            }} className="flex flex-column justify-content-center align-items-center gap-2 py-8" >
                <p className="m-0 text-xl text-center" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >JOURNEY MAP</p>
                <p className="m-0 text-center mb-6 font-bold" style={{ color: "white", fontSize: "3.25rem", wordBreak: "break-word" }}>
                    Your Recovery Journey in Easy Steps
                </p>
                <div className="flex flex-wrap justify-content-evenly xl:justify-content-between align-items-start px-4 md:px-6 gap-2">
                    {imagesWithDescriptions.map((item) => (
                        <div className="flex justify-content-center align-items-center flex-column gap-3">
                            <img src={item.src} />
                            <span className="text-white text-center w-20rem">{item.desc}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/*  Introduction */}
            <div style={{
                width: "100%",
                backgroundImage: "url('/IntroductionImg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                position: "relative"
            }}
                className="flex flex-column justify-content-start align-items-center gap-2 min-h-screen bg-cover">

                <p className="m-0 text-xl mt-6" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >DISCOVER</p>
                <p className="m-0 font-bold" style={{ fontSize: "3.25rem", color: "#2D3967" }} >Let's Explore</p>
                <p className="flex align-items-center m-0 font-bold" style={{ fontSize: "3.25rem", color: "#E3506B", lineHeight: "2rem" }} >
                    Mobithera <span style={{ fontSize: "1.5rem", marginTop: "-0.5rem" }}>™</span>
                </p>

                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "100vw",
                    minHeight: "100vh",
                    position: "absolute",
                }}>
                    <img
                        src="/PlayGif.gif"
                        alt="Play Animation"
                        style={{ width: "10rem", marginTop: "6rem", cursor: "pointer" }}
                    />
                </div>
            </div>

            {/*  Features And Benefits */}
            <div className="flex flex-column justify-content-center py-8" style={{backgroundColor: "#F5F5F5"}}>
                <div className="mb-5 px-8 flex flex-column align-items-center md:align-items-start">
                    <p className="m-0 text-xl mb-5 text-center md:text-left" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >INSIGHTS</p>
                    <p className="m-0 font-bold text-center md:text-left" style={{ color: "#2D3967", lineHeight: "3.25rem", fontSize: "3.25rem", wordBreak: "break-word" }} >
                        Better Patient Outcomes <br />
                        With Proven Technology
                    </p>
                </div>
                <FeaturesAndBenetfitsCarusel />
            </div>

            {/*  Blue Line */}
            <div className="flex flex-wrap justify-content-evenly align-items-center px-4 md:px-8 py-5 gap-5"
                style={{ backgroundColor: "#2D3967", width: "100%", minHeight: "20vh" }}>
                <div className="flex flex-column align-items-center">
                    <p className="m-0 text-5xl font-bold" style={{ color: "white" }}>95%</p>
                    <p className="m-0  text-md " style={{ color: "#9EA4B9" }}>AI Modal Accuracy</p>
                </div>

                <div className="flex flex-column align-items-center">
                    <p className="m-0 text-5xl font-bold" style={{ color: "white" }}>+2000</p>
                    <p className="m-0  text-md " style={{ color: "#9EA4B9" }}>AI-Powered Exercise</p>
                </div>

                <div className="flex flex-column align-items-center">
                    <p className="m-0 text-5xl font-bold" style={{ color: "white" }}>
                        <span className="text-lg md:text-2xl">max</span>{" "}
                        %5
                    </p>
                    <p className="m-0  text-md " style={{ color: "#9EA4B9" }}>Battery Usage</p>
                </div>

            </div>

            {/*  Exercise Library */}
            <div className="flex flex-column align-items-center py-8 px-4 md:px-8 gap-8" style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/ExerciseLibraryBg.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "#F5F5F5"
            }}
            >
                <div className="flex flex-column align-items-center gap-5">
                    <p className="m-0 text-xl text-center" style={{ color: "#727A99", letterSpacing: "4px" }} >EXERCISE  LIBRARY</p>
                    <p className="m-0 text-center font-bold" style={{ color: "#2D3967", fontSize: "3.25rem", lineHeight: "4.5rem", wordBreak: "break-word" }} >Explore 2000+ AI-Guided Exercises</p>
                    <p className="m-0 text-xl text-center" style={{ color: "#727A99" }} >Our exercise collection -with or without equipment- is designed for every stage of recovery, guided by your doctor, powered by AI in your language.</p>
                </div>
                <div className="grid">
                    <div className="col-8">
                        <div className="grid">
                            <div className="col">
                                <img src="/ExerciseLibrary-1.jpg" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                            </div>
                            <div className="col">
                                <img src="/ExerciseLibrary-2.jpg" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col">
                                <img src="/ExerciseLibrary-5.png" style={{width: "100%", height: "100%", backgroundColor: "rgba(245, 245, 245, 0.8)", objectFit: "cover"}} />
                            </div>
                            <div className="col">
                                <img src="/ExerciseLibrary-4.jpg" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <img src="/ExerciseLibrary-3.jpg" style={{width: "100%", height: "100%", objectFit: "cover"}} />
                    </div>
                </div>
            </div>

            <div style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/RequestDemoBackground.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative"
            }} className="flex flex-column justify-content-center align-items-center gap-8 px-4 md:px-8 py-8" >
                <div className="flex flex-column justify-content-center align-items-center gap-3">
                    <p className="m-0 text-xl text-center" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >PRIVACY POLICY</p>
                    <p className="m-0 text-center mb-6 font-bold" style={{ color: "white", fontSize: "3.25rem", lineHeight: "4rem", wordBreak: "break-word" }}>
                        Your Privacy Matters <br /> at Mobithera
                    </p>
                    <p className="m-0 text-xl text-white text-center" style={{ maxWidth: "60rem"}}>
                        At Mobithera, your trust matters. That’s why we’ve built our platform
                        with privacy at its core. We never record your video or audio during
                        exercises. Your camera and microphone are used only to provide
                        real-time guidance. Nothing is stored, saved, or shared.  You stay in
                        control of your data, and we ensure every session is safe, secure, and
                        completely private.
                    </p>
                </div>
                <div className="flex flex-wrap justify-content-center align-items-center gap-8 py-8">
                    <div className="flex align-items-center justify-content-center gap-4">
                        <img src="/NoCamera.png" />
                        <p className="m-0 text-center font-bold" style={{ color: "white", fontSize: "1rem"}}>
                            NO VIDEO <br /> RECORDING
                        </p>
                    </div>
                    <div className="flex align-items-center gap-4 justify-content-center">
                        <img src="/NoMicrophone.png" />
                        <p className="m-0 text-center font-bold" style={{ color: "white", fontSize: "1rem"}}>
                            WE DON'T KEEP <br /> YOUR VOICE
                        </p>
                    </div>
                </div>
            </div>

            {/*  Customer Satisfaction */}
            <div className="flex flex-column px-4 md:px-8 py-8 gap-8" style={{
                width: "100%",
                minHeight: "100vh",
                backgroundColor: "#FFFFFF"
            }}
            >
                <div className="flex flex-column align-items-center gap-4">
                    <p className="m-0 text-xl text-center md:text-left" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >REAL STORIES. REAL RESULTS.</p>
                    <div className="flex flex-wrap align-items-center justify-content-center text-center gap-3" style={{ fontSize: "3.25rem", lineHeight: "4.5rem" }}>
                        <p className="m-0 font-bold" style={{ color: "#2D3967" }} >Your Voice,</p>
                        <p className="m-0 font-bold" style={{ color: "#E3506B" }} >Our Value</p>
                    </div>
                    <p className="m-0 text-xl text-center" style={{ color: "#727A99" }} >Trusted by users on their recovery journey.</p>
                </div>
                <CustomerSatisfaction />
            </div>

            {/*  Demo Access */}
            <RequestDemo />

            {/*  Applications */}
            <DownloadApplicationSection />

            <Footer />
        </div>
    )
}

export default MainPage